import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { MODULOS } from "./GestorUsuarios";
async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token || "";
  return { "Content-Type": "application/json", "Authorization": `Bearer ${token}` };
}
export default function SuperAdmin({ onVolver, oscuro, usuario }) {
  const [tenants, setTenants] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [errorGeneral, setErrorGeneral] = useState("");
  const [formTenant, setFormTenant] = useState({});
  const [creandoTenant, setCreandoTenant] = useState(false);
  const [resultadoCrear, setResultadoCrear] = useState(null);
  const [tenantPlanId, setTenantPlanId] = useState("");
  const [nuevoPlan, setNuevoPlan] = useState("");
  const [cambiandoPlan, setCambiandoPlan] = useState(false);
  const [resultadoPlan, setResultadoPlan] = useState(null);
  const [tenantVaciarId, setTenantVaciarId] = useState("");
  const [nombreConfirmacion, setNombreConfirmacion] = useState("");
  const [vaciando, setVaciando] = useState(false);
  const [resultadoVaciar, setResultadoVaciar] = useState(null);
  const [tenantExtraId, setTenantExtraId] = useState("");
  const [extras, setExtras] = useState([]);
  const [cargandoExtras, setCargandoExtras] = useState(false);
  const [moduloExtraId, setModuloExtraId] = useState("");
  const [notaExtra, setNotaExtra] = useState("");
  const [guardandoExtra, setGuardandoExtra] = useState(false);
  const [impersonandoId, setImpersonandoId] = useState(null);
  const [errorImpersonar, setErrorImpersonar] = useState("");
  const cargarTenants = async () => {
    setCargando(true);
    setErrorGeneral("");
    try {
      const resp = await fetch("/api/listar-tenants", { method: "POST", headers: await authHeaders() });
      const data = await resp.json();
      if (!resp.ok || data.error) { setErrorGeneral(data.error || "Error listando tenants"); setCargando(false); return; }
      setTenants(data.tenants || []);
      setPlanes(data.planes || []);
    } catch (e) {
      setErrorGeneral("Error de conexión: " + e.message);
    }
    setCargando(false);
  };
  useEffect(() => { cargarTenants(); }, []);
  const crearTenant = async () => {
    setCreandoTenant(true);
    setResultadoCrear(null);
    try {
      const resp = await fetch("/api/crear-tenant", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify(formTenant),
      });
      const data = await resp.json();
      if (!resp.ok || data.error) {
        setResultadoCrear({ ok: false, msg: data.error || data.warning || "Error creando tenant" });
      } else {
        setResultadoCrear({ ok: true, msg: `Tenant #${data.tenant_id} "${data.tenant_nombre}" creado — plan ${data.plan}` });
        setFormTenant({});
        cargarTenants();
      }
    } catch (e) {
      setResultadoCrear({ ok: false, msg: "Error de conexión: " + e.message });
    }
    setCreandoTenant(false);
  };
  const cambiarPlan = async () => {
    if (!tenantPlanId || !nuevoPlan) return;
    setCambiandoPlan(true);
    setResultadoPlan(null);
    try {
      const resp = await fetch("/api/cambiar-plan-tenant", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ tenant_id: Number(tenantPlanId), plan_nombre: nuevoPlan }),
      });
      const data = await resp.json();
      if (!resp.ok || data.error) {
        setResultadoPlan({ ok: false, msg: data.error || "Error cambiando plan" });
      } else {
        setResultadoPlan({ ok: true, msg: `Tenant "${data.tenant_nombre}" ahora en plan ${data.plan_nuevo}` });
        cargarTenants();
      }
    } catch (e) {
      setResultadoPlan({ ok: false, msg: "Error de conexión: " + e.message });
    }
    setCambiandoPlan(false);
  };
  const vaciarTenant = async () => {
    if (!tenantVaciarId || !nombreConfirmacion.trim()) return;
    if (!window.confirm("¿Confirmás que querés vaciar TODOS los datos operativos del tenant seleccionado? Esta acción no se puede deshacer.")) return;
    setVaciando(true);
    setResultadoVaciar(null);
    try {
      const resp = await fetch("/api/vaciar-tenant", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ tenant_id: Number(tenantVaciarId), tenant_nombre_confirmacion: nombreConfirmacion.trim() }),
      });
      const data = await resp.json();
      if (!resp.ok || data.error) {
        setResultadoVaciar({ ok: false, msg: data.error || "Error vaciando tenant" });
      } else {
        setResultadoVaciar({ ok: data.success, msg: `Tenant "${data.tenant_nombre}": ${data.tablas_procesadas} tablas procesadas, ${data.tablas_con_error} con error, ${data.total_filas_borradas} filas borradas` });
        setNombreConfirmacion("");
      }
    } catch (e) {
      setResultadoVaciar({ ok: false, msg: "Error de conexión: " + e.message });
    }
    setVaciando(false);
  };
  const cargarExtras = async (tenantId) => {
    setTenantExtraId(tenantId);
    setExtras([]);
    if (!tenantId) return;
    setCargandoExtras(true);
    try {
      const resp = await fetch("/api/gestionar-modulo-extra", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ accion: "listar", tenant_id: Number(tenantId) }),
      });
      const data = await resp.json();
      if (resp.ok && !data.error) setExtras(data.extras || []);
    } catch (e) { /* silencioso */ }
    setCargandoExtras(false);
  };
  const agregarExtra = async () => {
    if (!tenantExtraId || !moduloExtraId) return;
    setGuardandoExtra(true);
    try {
      const resp = await fetch("/api/gestionar-modulo-extra", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ accion: "agregar", tenant_id: Number(tenantExtraId), modulo_id: Number(moduloExtraId), nota: notaExtra }),
      });
      const data = await resp.json();
      if (resp.ok && !data.error) { setModuloExtraId(""); setNotaExtra(""); cargarExtras(tenantExtraId); }
    } catch (e) {}
    setGuardandoExtra(false);
  };
  const quitarExtra = async (moduloId) => {
    setGuardandoExtra(true);
    try {
      const resp = await fetch("/api/gestionar-modulo-extra", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ accion: "quitar", tenant_id: Number(tenantExtraId), modulo_id: moduloId }),
      });
      const data = await resp.json();
      if (resp.ok && !data.error) cargarExtras(tenantExtraId);
    } catch (e) {}
    setGuardandoExtra(false);
  };
  // "Ver como" — pide una sesión real del Administrador del tenant, guarda
  // la propia sesión de superadmin para poder volver, y recarga la app ya
  // logueada como ese Administrador. Ver BarraImpersonacion.js para el
  // botón de "Salir" que revierte esto.
  const impersonarTenant = async (tenantId, tenantNombre) => {
    if (!window.confirm(`¿Entrar a ALQOS como el Administrador de "${tenantNombre}"? Vas a ver exactamente lo que ve ese usuario. Queda registrado en el log de auditoría.`)) return;
    setImpersonandoId(tenantId);
    setErrorImpersonar("");
    try {
      const resp = await fetch("/api/impersonar-tenant", {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ tenant_id: Number(tenantId) }),
      });
      const data = await resp.json();
      if (!resp.ok || data.error) {
        setErrorImpersonar(data.error || "No se pudo iniciar la impersonación");
        setImpersonandoId(null);
        return;
      }
      const { data: sesionActual } = await supabase.auth.getSession();
      if (sesionActual?.session) {
        localStorage.setItem("alqos_sesion_superadmin", JSON.stringify({
          access_token: sesionActual.session.access_token,
          refresh_token: sesionActual.session.refresh_token,
        }));
      }
      const { error: otpError } = await supabase.auth.verifyOtp({
        token_hash: data.hashed_token,
        type: "magiclink",
      });
      if (otpError) {
        setErrorImpersonar("No se pudo activar la sesión: " + otpError.message);
        setImpersonandoId(null);
        return;
      }
      localStorage.setItem("alqos_impersonando", JSON.stringify({
        tenant_id: tenantId,
        tenant_nombre: data.tenant_nombre,
        admin_email: data.admin_email,
        iniciado_en: new Date().toISOString(),
      }));
      window.location.reload();
    } catch (e) {
      setErrorImpersonar("Error de conexión: " + e.message);
      setImpersonandoId(null);
    }
  };
  const bg      = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg  = oscuro ? "#0d2160" : "white";
  const texto   = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde   = oscuro ? "#1e3a8a" : "#eee";
  const navBg   = oscuro ? "#060f30" : "#09184D";
  const subtexto= oscuro ? "#9aabd4" : "#808085";
  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto };
  const lbl = { fontSize:"12px", color:oscuro?"#9aabd4":"#555", fontWeight:"600", display:"block", marginTop:"12px" };
  const card= { background:cardBg, borderRadius:"12px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"16px" };
  const btn = { padding:"12px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer" };
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", gap:"12px", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
        <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>⚙️ Super Admin</span>
      </div>
      <div style={{ padding:"0 1.5rem 3rem", maxWidth:"800px", margin:"0 auto" }}>
        {/* ── LISTADO DE TENANTS ── */}
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 12px" }}>📋 Tenants ({tenants.length})</h3>
          {cargando && <p style={{ fontSize:"12px", color:subtexto }}>Cargando...</p>}
          {errorGeneral && <p style={{ fontSize:"12px", color:"#e63946" }}>{errorGeneral}</p>}
          {errorImpersonar && <p style={{ fontSize:"12px", color:"#e63946", fontWeight:"600" }}>{errorImpersonar}</p>}
          {!cargando && !errorGeneral && (
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"12px" }}>
                <thead>
                  <tr style={{ borderBottom:`1px solid ${borde}`, color:subtexto, textAlign:"left" }}>
                    <th style={{ padding:"6px" }}>ID</th>
                    <th style={{ padding:"6px" }}>Nombre</th>
                    <th style={{ padding:"6px" }}>Plan</th>
                    <th style={{ padding:"6px" }}>Usuarios</th>
                    <th style={{ padding:"6px" }}>Estado</th>
                    <th style={{ padding:"6px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {tenants.map(t => (
                    <tr key={t.id} style={{ borderBottom:`1px solid ${borde}` }}>
                      <td style={{ padding:"6px", color:texto }}>{t.id}</td>
                      <td style={{ padding:"6px", color:texto, fontWeight:"600" }}>{t.nombre}</td>
                      <td style={{ padding:"6px", color:texto }}>{t.plan_nombre}</td>
                      <td style={{ padding:"6px", color:texto }}>{t.cantidad_usuarios}</td>
                      <td style={{ padding:"6px", color:texto }}>{t.estado || "-"}</td>
                      <td style={{ padding:"6px" }}>
                        {t.id !== 1 && (
                          <button onClick={()=>impersonarTenant(t.id, t.nombre)} disabled={impersonandoId===t.id}
                            style={{ background:"#f59e0b", color:"#1a1a1a", border:"none", borderRadius:"6px", padding:"4px 10px", cursor:"pointer", fontSize:"11px", fontWeight:"700", opacity:impersonandoId===t.id?0.6:1 }}>
                            {impersonandoId===t.id ? "Entrando..." : "🎭 Ver como"}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <button onClick={cargarTenants} style={{ marginTop:"12px", padding:"6px 12px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color:subtexto, fontSize:"11px" }}>🔄 Refrescar</button>
        </div>
        {/* ── CREAR TENANT ── */}
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#22c55e", margin:"0 0 12px" }}>➕ Crear tenant nuevo</h3>
          <span style={lbl}>Nombre del tenant *</span>
          <input style={inp} value={formTenant.tenant_nombre||""} onChange={e=>setFormTenant(f=>({...f,tenant_nombre:e.target.value}))} placeholder="Ej: Cliente Nuevo SA"/>
          <span style={lbl}>Plan</span>
          <select style={inp} value={formTenant.plan_nombre||""} onChange={e=>setFormTenant(f=>({...f,plan_nombre:e.target.value}))}>
            <option value="">— Full (default) —</option>
            {planes.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
          </select>
          <span style={lbl}>Email del Administrador *</span>
          <input style={inp} value={formTenant.admin_email||""} onChange={e=>setFormTenant(f=>({...f,admin_email:e.target.value}))} placeholder="admin@cliente.com"/>
          <span style={lbl}>Contraseña *</span>
          <input style={inp} type="password" value={formTenant.admin_password||""} onChange={e=>setFormTenant(f=>({...f,admin_password:e.target.value}))} placeholder="Mínimo 6 caracteres"/>
          <span style={lbl}>Nombre del Administrador *</span>
          <input style={inp} value={formTenant.admin_nombre||""} onChange={e=>setFormTenant(f=>({...f,admin_nombre:e.target.value}))}/>
          <span style={lbl}>Empresa *</span>
          <input style={inp} value={formTenant.admin_empresa||""} onChange={e=>setFormTenant(f=>({...f,admin_empresa:e.target.value}))}/>
          <span style={lbl}>Dirección empresa (opcional)</span>
          <input style={inp} value={formTenant.admin_empresa_direccion||""} onChange={e=>setFormTenant(f=>({...f,admin_empresa_direccion:e.target.value}))}/>
          <span style={lbl}>CUIT empresa (opcional)</span>
          <input style={inp} value={formTenant.admin_empresa_cuit||""} onChange={e=>setFormTenant(f=>({...f,admin_empresa_cuit:e.target.value}))}/>
          <span style={lbl}>Celular (opcional)</span>
          <input style={inp} value={formTenant.admin_celular||""} onChange={e=>setFormTenant(f=>({...f,admin_celular:e.target.value}))}/>
          <button onClick={crearTenant} disabled={creandoTenant} style={{...btn, width:"100%", marginTop:"16px", background:"#22c55e", opacity:creandoTenant?.7:1}}>
            {creandoTenant ? "Creando..." : "Crear tenant"}
          </button>
          {resultadoCrear && (
            <p style={{ fontSize:"12px", marginTop:"10px", color: resultadoCrear.ok ? "#22c55e" : "#e63946", fontWeight:"600" }}>{resultadoCrear.msg}</p>
          )}
        </div>
        {/* ── CAMBIAR PLAN ── */}
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#3b82f6", margin:"0 0 12px" }}>🔄 Cambiar plan de un tenant</h3>
          <span style={lbl}>Tenant</span>
          <select style={inp} value={tenantPlanId} onChange={e=>setTenantPlanId(e.target.value)}>
            <option value="">— Seleccionar —</option>
            {tenants.map(t => <option key={t.id} value={t.id}>#{t.id} — {t.nombre} (hoy: {t.plan_nombre})</option>)}
          </select>
          <span style={lbl}>Nuevo plan</span>
          <select style={inp} value={nuevoPlan} onChange={e=>setNuevoPlan(e.target.value)}>
            <option value="">— Seleccionar —</option>
            {planes.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
          </select>
          <button onClick={cambiarPlan} disabled={cambiandoPlan || !tenantPlanId || !nuevoPlan} style={{...btn, width:"100%", marginTop:"16px", background:"#3b82f6", opacity:(cambiandoPlan||!tenantPlanId||!nuevoPlan)?.5:1}}>
            {cambiandoPlan ? "Cambiando..." : "Cambiar plan"}
          </button>
          {resultadoPlan && (
            <p style={{ fontSize:"12px", marginTop:"10px", color: resultadoPlan.ok ? "#22c55e" : "#e63946", fontWeight:"600" }}>{resultadoPlan.msg}</p>
          )}
        </div>
        {/* ── VACIAR TENANT ── */}
        <div style={{...card, border:"1.5px solid #e6394655"}}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#e63946", margin:"0 0 12px" }}>🗑️ Vaciar datos de un tenant</h3>
          <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 10px" }}>Borra todos los datos operativos del tenant (NC, OTs, clientes, etc.) — el tenant y sus usuarios quedan intactos. El tenant #1 está bloqueado y no se puede vaciar por acá.</p>
          <span style={lbl}>Tenant</span>
          <select style={inp} value={tenantVaciarId} onChange={e=>{setTenantVaciarId(e.target.value); setNombreConfirmacion("");}}>
            <option value="">— Seleccionar —</option>
            {tenants.filter(t=>t.id!==1).map(t => <option key={t.id} value={t.id}>#{t.id} — {t.nombre}</option>)}
          </select>
          <span style={lbl}>Escribí el nombre exacto del tenant para confirmar</span>
          <input style={inp} value={nombreConfirmacion} onChange={e=>setNombreConfirmacion(e.target.value)} placeholder={tenants.find(t=>String(t.id)===String(tenantVaciarId))?.nombre || ""}/>
          <button onClick={vaciarTenant} disabled={vaciando || !tenantVaciarId || !nombreConfirmacion.trim()} style={{...btn, width:"100%", marginTop:"16px", background:"#e63946", opacity:(vaciando||!tenantVaciarId||!nombreConfirmacion.trim())?.5:1}}>
            {vaciando ? "Vaciando..." : "Vaciar tenant"}
          </button>
          {resultadoVaciar && (
            <p style={{ fontSize:"12px", marginTop:"10px", color: resultadoVaciar.ok ? "#22c55e" : "#e63946", fontWeight:"600" }}>{resultadoVaciar.msg}</p>
          )}
        </div>
        {/* ── EXCEPCIONES POR TENANT ── */}
        <div style={card}>
          <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#f59e0b", margin:"0 0 12px" }}>🔓 Módulos extra por tenant (excepciones fuera del plan)</h3>
          <span style={lbl}>Tenant</span>
          <select style={inp} value={tenantExtraId} onChange={e=>cargarExtras(e.target.value)}>
            <option value="">— Seleccionar —</option>
            {tenants.map(t => <option key={t.id} value={t.id}>#{t.id} — {t.nombre} (plan {t.plan_nombre})</option>)}
          </select>
          {tenantExtraId && (
            <>
              {cargandoExtras && <p style={{ fontSize:"12px", color:subtexto, marginTop:"10px" }}>Cargando...</p>}
              {!cargandoExtras && (
                <div style={{ marginTop:"12px" }}>
                  {extras.length === 0 && <p style={{ fontSize:"12px", color:subtexto }}>Sin excepciones cargadas para este tenant.</p>}
                  {extras.map(ex => {
                    const mod = MODULOS.find(m => m.id === ex.modulo_id);
                    return (
                      <div key={ex.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 10px", background:oscuro?"#0a1030":"#f5f3ff", borderRadius:"8px", marginBottom:"6px" }}>
                        <span style={{ fontSize:"12px", color:texto }}>{mod?.icono} {mod?.nombre || `Módulo #${ex.modulo_id}`} {ex.nota && <em style={{ color:subtexto }}>— {ex.nota}</em>}</span>
                        <button onClick={()=>quitarExtra(ex.modulo_id)} disabled={guardandoExtra} style={{ background:"none", border:"1px solid #e63946", color:"#e63946", borderRadius:"6px", padding:"3px 8px", cursor:"pointer", fontSize:"10px" }}>Quitar</button>
                      </div>
                    );
                  })}
                  <div style={{ display:"flex", gap:"8px", marginTop:"12px" }}>
                    <select style={{...inp, marginTop:0, flex:2}} value={moduloExtraId} onChange={e=>setModuloExtraId(e.target.value)}>
                      <option value="">— Módulo a agregar —</option>
                      {MODULOS.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                    </select>
                    <input style={{...inp, marginTop:0, flex:2}} placeholder="Nota (opcional)" value={notaExtra} onChange={e=>setNotaExtra(e.target.value)}/>
                    <button onClick={agregarExtra} disabled={guardandoExtra || !moduloExtraId} style={{...btn, background:"#f59e0b", flex:1, padding:"8px", fontSize:"12px"}}>+ Agregar</button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
